import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';

import {
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { ActionTypes, CardTypes } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

import { goToInstructionsCard, continueToMultiActionsCard } from './actions';

import ThumbnailContainer from '../../components/RecordVideo/ThumbnailContainer';
import CopyLink from '../../components/RecordVideo/VideoLinkContainer';
import BackButton from '../../components/RecordVideo/BackButton';

import NextAction from '../Widget/NextAction';

const RecordVideoConfirmation = props => {
    const [videoIsReady, setVideoIsReady] = useState(false);

    return (
        <TransitionContainer
            zIndex={5}
            isSubmitting={props.isSubmitting}
            isBackTransition={props.isBackTransition}
        >
            <ConfirmationCard
                rightAlign
                thankYouText={props.thankYouText}
                thankYouTitle={props.thankYouTitle}
                altShareDefaultTwitterFacebookMessage={
                    props.altShareDefaultTwitterFacebookMessage
                }
                altShareCustomFacebookMessage={
                    props.altShareCustomFacebookMessage
                }
                altShareCustomTwitterMessage={
                    props.altShareCustomTwitterMessage
                }
                altSharingURL={props.videoURL}
                altSharingButtonsAreShort={true}
                titleComponent={
                    <Title>
                        <Span>
                            {copyFor('postRecord', 'title', 'recordvideo')}
                        </Span>
                    </Title>
                }
                customBackButton={
                    <BackButton
                        onClick={() => {
                            props.setExitingCardProps('recordvideo', props, props.exitingAction);
                            props.goToInstructionsCard({direction:'back'})
                        }}
                    />
                }
                linkComponent={
                    <CopyLink
                        videoURL={props.videoURL}
                        fullVideoURL={props.fullVideoURL}
                        downloadIsReady={videoIsReady}
                    />
                }
                thumbnailComponent={
                    <ThumbnailContainer
                        src={props.thumbnailURL}
                        href={props.videoURL}
                        setVideoIsReady={setVideoIsReady}
                    />
                }
                beforeAdvancing={() => {
                    props.setExitingCardProps('recordvideo', props, props.exitingAction);
                }}
                noCountdown={true}
                {...props}
                hideFooter={true}
                hideImage={true}
                nextStepButton={ props.isMultiActionsCard &&
                    (<NextAction
                        isEndCard={false}
                        hideFooter={true}
                        exitingAction={props.exitingAction}
                        beforeAdvancing={() => props.continueToMultiActionsCard(props.actionIdentifier)}
                        dontGoToNextCard={true}
                        noCountdown={true}
                    />)
                }
            />
        </TransitionContainer>
    );
};

RecordVideoConfirmation.propTypes = {
    actionIdentifier: PropTypes.string,
    altShareDefaultTwitterFacebookMessage: PropTypes.string,
    altShareCustomFacebookMessage: PropTypes.string,
    altShareCustomTwitterMessage: PropTypes.string,
    card: PropTypes.object,
    enableAltEndCardSharing: PropTypes.bool,
    exitingAction: PropTypes.object.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isPortrait: PropTypes.bool,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    repFullName: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    partnerName: PropTypes.string,
    fullVideoURL: PropTypes.string,
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'recordvideo',
            ['/recordvideo/noemailsuccess'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const fullVideoURL = state.recordVideo.fullVideoURL;
        const thumbnailURL = state.recordVideo.thumbnailURL;
        const videoURL = state.recordVideo.videoURL;

        const partnerName = state.widget.activeAction.partner
                ? state.widget.activeAction.partner.name
                : 'Speakable';


        const altShareDefaultTwitterFacebookMessage = 
            copyFor('postRecord', 'altShareMessage', 'recordvideo')
                .replace(/@userVideoUrl/g, videoURL);

        const altShareCustomFacebookMessage =
            state.widget.activeAction.altSharingFacebookMessage &&
            state.widget.activeAction.altSharingFacebookMessage
                .replace(/@userVideoUrl/g, videoURL);

        const altShareCustomTwitterMessage =
            state.widget.activeAction.altSharingTwitterMessage && 
            state.widget.activeAction.altSharingTwitterMessage
                .replace(/@userVideoUrl/g, videoURL);

        const localRepData = state.localRep.localRepData || {};
        const repDistrict = localRepData.district || 'your district';
        const repState = localRepData.stateName || 'your state';

        const thankYouText = 
            (state.widget.activeAction.postRecordDescription || 
            copyFor('postRecord', 'description', 'recordvideo'))
            .replace(/@partnerName/g, partnerName)
            .replace(/@state/g, repState)
            .replace(/@district/g, repDistrict);

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            altShareDefaultTwitterFacebookMessage,
            altShareCustomFacebookMessage,
            altShareCustomTwitterMessage,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            enableAltEndCardSharing: state.widget.activeAction.enableAltEndCardSharing,
            exitingAction: state.widget.activeAction,
            isPortrait: state.widget.isMobileResolution,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            partnerName,
            repFullName: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative[0].fullName
                : '',
            thankYouTitle: state.widget.activeAction.postRecordTitle || copyFor('postRecord', 'title', 'recordvideo'),
            thankYouText,
            fullVideoURL,
            thumbnailURL,
            videoURL,
        };
    },
    { setExitingCardProps, goToInstructionsCard, continueToMultiActionsCard },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.RecordVideo) return true;
            return next === prev;
        }
    }
)(RecordVideoConfirmation);
